module.exports = __webpack_public_path__ + "linkedin1.png?2e82984a22e2bdcf614f37f72c337893";


//////////////////
// WEBPACK FOOTER
// ./src/assets/linkedin1.png
// module id = 30
// module chunks = 0